var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite = function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.551 5.745a.5.5 0 0 1 .9 0L14.3 9.483l4.144.6a.5.5 0 0 1 .276.854l-3 2.9.708 4.1a.5.5 0 0 1-.724.528L12 16.531 8.289 18.47a.5.5 0 0 1-.724-.528l.708-4.1-3-2.9a.5.5 0 0 1 .276-.854l4.145-.6Z",
    className: "favourite_svg__a"
  })));
};
export default SvgFavourite;